import { useEffect, useRef, useState, useCallback } from 'react';

export default function RunSim(games) {
    const [results, setResults] = useState({
        percent: {},
        numSimulations: 0,
        avgOdds: 0,
        loading: false,
    });

    const week = 17;
    const runIdRef = useRef(0);
    const workerRef = useRef(null);
    const hasAutoRunRef = useRef(false);

    const gamesRef = useRef(games);
    gamesRef.current = games;

    const isPopulated = Array.isArray(games) && games.length > 0;

    useEffect(() => {
        workerRef.current = new Worker(
            new URL('./simWorker.js', import.meta.url)
        );
        workerRef.current.onmessage = (e) => {
            if (e.data.runId === runIdRef.current) {
                setResults(e.data);
            }
        };
        return () => workerRef.current.terminate();
    }, []);

    const runSimulation = useCallback((simCount) => {
        if (!workerRef.current) return;
        if (!Array.isArray(gamesRef.current) || gamesRef.current.length === 0) return;

        const thisRun = ++runIdRef.current;
        setResults(prev => ({ ...prev, loading: true }));
        workerRef.current.postMessage({
            games: gamesRef.current,
            week,
            totalSimulations: simCount,
            runId: thisRun,
        });
    }, []);

    // Auto-run exactly once, as soon as games actually has data
    useEffect(() => {
        if (isPopulated && !hasAutoRunRef.current && workerRef.current) {
            hasAutoRunRef.current = true;
            //runSimulation(10000);
            
        }
    }, [isPopulated, runSimulation]);

    return { ...results, runSimulation };
}